export function Card({ children, className }) {
  return (
    <div
      className={`rounded-lg shadow ring-1 ring-black/5 bg-white ${className}`}
    >
      {children}
    </div>
  );
}
